import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import image from "../../assets/images/dummy_pic.jpeg";
import { BaseURL, uniqueToken } from "../../api/DataApis";

const View = (props) => {
  document.title = "Users | View";
  const [Users, setUsers] = useState([]);
  const [charger, setCharger] = useState(null);
  const params = useParams();
  let ChargerID = params.cid;
  let navigate = useNavigate();
  let location = useLocation();

  const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/chargers/details/${ChargerID}`;
    
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
  
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        setCharger(res.data.data[0]); // Set the first item in the data array
      } else {
        console.error("No charger data found");
      }
    } catch (error) {
      console.error("Error fetching charger data:", error);
    }
  }
  

  useEffect(() => {
    fetchData();
  }, []);
  console.log("chargerData", charger);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title">Charger Details</h1>
              <div id="printablediv">
                <section className="panel">
                  <div className="profile-view-head">
                    <img
                      className="imagev"
                      src={charger?.charger_image || image}
                      alt="Charger Station"
                    />
                    <h5>{charger?.station_name}</h5>
                
                  </div>
                  <div className="panel-body profile-view-dis">
                    <h3>Charger Information</h3>
                    <div className="row">
                      <div className="profile-view-tab">
                        <p><span>Charger Name</span>:<b>{charger?.charger?.charger_name}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Address</span>:<b>{charger?.address}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Status</span>:<b>{charger?.status}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Latitude</span>:<b>{charger?.latitude}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Longitude</span>:<b>{charger?.longitude}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Charger Type</span>:<b>{charger?.charger?.master_charger_type_id}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>IMEI Number</span>:<b>{charger?.charger?.imei_number}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Connectors Type</span>:<b>{""}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Power</span>:<b>{charger?.charger?.select_power_str}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Service Provider</span>:<b>{charger?.charger?.service_provider_str}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Amenities</span>:<b>{charger?.charger?.select_amenity_str}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Supported Vehicles</span>:<b>{charger?.charger?.select_vehicle_str}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Booking Amount</span>:<b>{charger?.charger?.booking_amount}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Booking Cancel Amount</span>:<b>{charger?.charger?.booking_cancel_amount}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Charger Estimated Bid Price</span>:<b>{charger?.charger?.charger_estimated_bid_price}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Tax</span>:<b>{charger?.charger?.tax}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Other Charges</span>:<b>{charger?.charger?.other_charger}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Per Unit Price without GST</span>:<b>{charger?.charger?.per_unit_price_without_gst}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Per Unit Price with GST</span>:<b>{charger?.charger?.per_unit_price_with_gst}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Local Hourse
                        </span>:<b>{charger?.charger?.local_hours}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Security Code</span>:<b>{charger?.charger?.security_code}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Charger con Type</span>:<b>{""}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Connectors Type</span>:<b>{charger?.charger?.select_vehicle_str}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Power</span>:<b>{charger?.charger?.select_power_str}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span> Service Provider</span>:<b>{charger?.charger?.service_provider_str}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Amenity</span>:<b>{charger?.charger?.select_amenity_str}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Select Vechicle</span>:<b>{charger?.charger?.select_vehicle_str}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Payment Type</span>:<b>{""}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Charger Type</span>:<b>{charger?.charger?.select_vehicle_str}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Max voltage</span>:<b>{charger?.charger?.max_voltage}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Max current</span>:<b>{charger?.charger?.max_current}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Minimum C One Value</span>:<b>{charger?.charger?.minimum_c_one_value}</b></p>
                      </div>
                      <div className="profile-view-tab">
                        <p><span>Station Name</span>:<b>{charger?.station_name}</b></p>
                      </div>
                    </div>
                    
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  
};

export default View;
